import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameViewRoutingModule } from './game-view-routing.module';
import { GameViewComponent } from './game-view.component';
import { HeaderBarModule } from '../header-bar/header-bar.module';
import { MenuBarModule } from '../menu-bar/menu-bar.module';
import { NumbersGridModule } from '../numbers-grid/numbers-grid.module';
import { RollingNumbersComponent } from './rolling-numbers/rolling-numbers.component';
import { NumberModule } from '../number/number.module';
import { TipSelectionComponent } from './tip-selection/tip-selection.component';
import { PunterBarModule } from '../punter-bar/punter-bar.module';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    GameViewRoutingModule,
    HeaderBarModule,
    MenuBarModule,
    NumbersGridModule,
    NumberModule,
    PunterBarModule,
    FormsModule,
    SharedModule
  ],
  declarations: [GameViewComponent, RollingNumbersComponent, TipSelectionComponent, LoginComponent]
})
export class GameViewModule {
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/game-view/game-view.module.ts